import { apiUrl } from '../content/landingContent.js'

// Reconcilia o cadastro pago no retorno do Stripe (`/?signup=success&
// session_id=...`). O provisionamento normal é feito pelo webhook
// checkout.session.completed no backend; esta chamada é a rede de segurança
// pra quando o webhook não chega. Idempotente do lado do servidor.
//
// Retorna { status, email }, onde status é:
//   'completed'       — conta criada (ou já existia)
//   'pending_payment' — pagamento ainda não confirmado no Stripe
//   'processing'      — em andamento, tentar de novo depois
//   'failed'          — não foi possível criar a conta (precisa de suporte)
//   'error'           — falha de rede/servidor ao consultar
export async function finalizeSignup(sessionId) {
  try {
    const res = await fetch(`${apiUrl}/api/public/tenants/finalize-signup`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: sessionId }),
    })
    const data = await res.json().catch(() => ({}))
    if (!res.ok) return { status: data.status || 'error', email: data.email || null }
    return { status: data.status || 'processing', email: data.email || null }
  } catch {
    return { status: 'error', email: null }
  }
}
